import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
import profCaio from "@/assets/orto/prof-caio.jpg.asset.json";

const TITLE = "Pós em Prescrição de Exercícios | Versão A | FEO";
const DESC =
  "Versão A da LP: pós-graduação 100% online em Prescrição de Exercícios para Fisioterapeutas. 14 módulos, 360h, reconhecida pelo MEC. Prescreva com critério, dose e progressão.";
const URL = "https://fisioemortopedia.com.br/prescricao1";

export const Route = createFileRoute("/prescricao1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: PrescricaoLP1,
});

function PrescricaoLP1() {
  return (
    <PosFigmaLP
      product="prescricao"
      heroBadge="Pós-Graduação 100% online"
      heroTitle={["Prescrição", "de Exercícios", "para fisioterapeutas"]}
      heroSubtitle="Aprenda a prescrever exercício com critério clínico, dose, carga, progressão e regressão, para cada paciente, em qualquer fase do tratamento."
      coordenadorNome="Caio Sain Vallio"
      coordenadorFoto={profCaio.url}
      coordenadorBio="Coordenador da pós em Prescrição de Exercícios da FEO. Pesquisador e referência em prescrição baseada em evidências, dosagem de treinamento e progressão de carga aplicada à reabilitação."
      ementaSubtitle="Baixe o PDF com a grade completa dos módulos, os professores e o cronograma das aulas da pós em Prescrição de Exercícios."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
